module.exports = __webpack_public_path__ + "images/nascc_registration_uplogo.1782880901430.png";